const attach = (Vue) => {
    Vue.directive('blur', directives.blur)
    Vue.directive('img', directives.img)
}

const directives = {
    blur: {
        beforeMount(el, binding) {
            binding.value.classes && binding.value.classes.forEach(item => {
                Array.from(el.querySelectorAll(item))
                    .forEach(item => {
                        item.classList.add('blur')
                })
            })
        },
        updated(el, binding) {
            binding.dir.beforeMount(el, binding)
        }
    },
    img: {
        beforeMount(el, binding) {
            binding.value.classes && binding.value.classes.forEach(item => {
                Array.from(el.querySelectorAll(item))
                    .forEach(item => {
                        if (item.tagName === 'IMG')
                            item.onload = () => {
                                if (item.naturalHeight > item.naturalWidth) {
                                    item.style.maxHeight = 'initial';
                                    item.style.height = '100%';
                                } else {
                                    item.style.maxWidth = 'initial';
                                    item.style.width = '100%';
                                }
                            }
                    })
            })
        },
        updated(el, binding) {
            binding.dir.beforeMount(el, binding)
        }
    }
}

export default attach